import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot } from '@angular/router';
import { User } from 'src/app/models/ui/User';
import { APISettings } from '../../misc/settings';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { JwtHelperService } from "@auth0/angular-jwt";
import { map } from 'rxjs/operators';

@Injectable()
export class AuthService {
  loggedIn = true;

  constructor(private router: Router, private http: HttpClient,private _jwtHelper: JwtHelperService) {}

  logIn(login: string, password: string) {
    this.loggedIn = true;
    this.router.navigate(['/']);
  }

  logOut() {
    this.loggedIn = false;
    localStorage.removeItem("UserID");
    localStorage.removeItem("ProviderCurrentUsername");
    localStorage.removeItem("loggedUsername");
    localStorage.removeItem("currentProvider");
    localStorage.removeItem("UserRole");
    localStorage.removeItem("ProviderToken");
    localStorage.removeItem("currentSessionTokenKey");
    localStorage.setItem("isAuthorized", "false");
    this.router.navigate(['/login-form']);
  }
  public isUserAuthenticated = (): boolean => {
    var token = localStorage.getItem('ProviderToken');
    return token && !this._jwtHelper.isTokenExpired(token) as any;
  }
  get isLoggedIn() {
    return this.loggedIn;
  }


  checkUserDetails(user: User): Observable<string> {
    return this.http.post(`${APISettings.apiBaseAddress}/api/user/checkuser`, user, { observe: 'response' })
      .pipe(
        map((response: HttpResponse<any>) => {
          const token = response.headers.get('Authorization');
          if (token) {
            const tokenValue = token.split(' ')[1]; 
            return tokenValue;
          }
          return response.body;
        })
      );
  }
}

@Injectable()
export class AuthGuardService implements CanActivate {
    constructor(private router: Router, private authService: AuthService) {}

    canActivate(route: ActivatedRouteSnapshot): boolean {
        const isLoggedIn = this.authService.isLoggedIn;
        const isLoginForm = route.routeConfig.path === 'password-form';

        if (isLoggedIn && isLoginForm) {
            this.router.navigate(['/']);
            return false;
        }

        if (!isLoggedIn && !isLoginForm) {
            //this.router.navigate(['/password-form']);
        }

        return isLoggedIn || isLoginForm;
    }
}
